/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../axios-client";
import type { Client, RequestConfig, ResponseErrorConfig } from "../../axios-client";
import type { PostApiBarberAppointmentsIdManualAcceptMutationRequest, PostApiBarberAppointmentsIdManualAcceptMutationResponse, PostApiBarberAppointmentsIdManualAcceptPathParams, PostApiBarberAppointmentsIdManualAccept400, PostApiBarberAppointmentsIdManualAccept401, PostApiBarberAppointmentsIdManualAccept403, PostApiBarberAppointmentsIdManualAccept404, PostApiBarberAppointmentsIdManualAccept500 } from "../entities/PostApiBarberAppointmentsIdManualAccept";

function getPostApiBarberAppointmentsIdManualAcceptUrl(id: PostApiBarberAppointmentsIdManualAcceptPathParams["id"]) {
  const res = { method: 'POST', url: `/api/barber/appointments/${id}/manual-accept` as const }
  return res
}

/**
 * @description Ручной вызов онлайн- или офлайн-клиента мастером своей активной смены.
 * @summary Вызвать выбранного клиента
 * {@link /api/barber/appointments/:id/manual-accept}
 */
export async function postApiBarberAppointmentsIdManualAccept(id: PostApiBarberAppointmentsIdManualAcceptPathParams["id"], data: PostApiBarberAppointmentsIdManualAcceptMutationRequest, config: Partial<RequestConfig<PostApiBarberAppointmentsIdManualAcceptMutationRequest>> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config

  const requestData = data

  const res = await request<PostApiBarberAppointmentsIdManualAcceptMutationResponse, ResponseErrorConfig<PostApiBarberAppointmentsIdManualAccept400 | PostApiBarberAppointmentsIdManualAccept401 | PostApiBarberAppointmentsIdManualAccept403 | PostApiBarberAppointmentsIdManualAccept404 | PostApiBarberAppointmentsIdManualAccept500>, PostApiBarberAppointmentsIdManualAcceptMutationRequest>({ method : "POST", url : getPostApiBarberAppointmentsIdManualAcceptUrl(id).url.toString(), data : requestData, ... requestConfig })
  return res.data
}